// App.js — routes (slicer pattern).
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login/Login';
import LoginCallback from './components/Login/LoginCallback';
import Logout from './components/Logout';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer/Footer';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';

const App = () => {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <div className="app-container">
            <main className="main-container">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/login/callback" element={<LoginCallback />} />
                <Route path="/logout" element={<Logout />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
